<script>
import { mapActions, mapGetters } from 'vuex';
import { getPusherInstance } from '@/utils';

const SEATING_CHANGE = 'seating-change';

export default {
  name: 'SeatingDataProvider',
  created() {
    this.fetchItems();

    // The organizer re-seats people while the event is running, so the block has
    // to follow along on its own — a participant is not going to reload the app
    // to find out they were moved.
    this.pusher = getPusherInstance({ isReady: true });
    this.pusher.bind(SEATING_CHANGE, this.onSeatingChange);
  },
  beforeDestroy() {
    this.pusher?.unbind?.(SEATING_CHANGE, this.onSeatingChange);
  },
  methods: {
    ...mapActions('Seating', ['fetchItems', 'refresh']),
    onSeatingChange() {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters('Seating', [
      'getMySeat',
      'getGuestSeats',
      'hasGuests',
      'hasSeating',
      'isLoading',
      'failed'
    ])
  },
  render() {
    return this.$scopedSlots.default({
      mySeat: this.getMySeat,
      guestSeats: this.getGuestSeats,
      hasGuests: this.hasGuests,
      hasSeating: this.hasSeating,
      loading: this.isLoading,
      failed: this.failed,
      refresh: this.refresh
    });
  }
};
</script>
